import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { getActiveComponentDesign } from './getActiveComponentDesignSelector';

export const getActiveMaterialSettings = createSelector(
  (state: RootState) => state.application.insertingObjectInfo,
  (state: RootState) => state.settingsDatabase.materialSettings,
  getActiveComponentDesign,
  (insertingObjectInfo, materialSettings, activeComponentDesign) => {
    if (insertingObjectInfo && insertingObjectInfo.type === 'componentDesign') {
      return insertingObjectInfo.materialSettings;
    }
    if (activeComponentDesign) {
      return materialSettings[activeComponentDesign.guid];
    }
    return null;
  },
);
